import { Base } from '@wilson/base';
import type { User } from '../accounts/User';
import { ActivityCategoryContract } from '../activities/activity-category';
import type { OrganizationalUnit } from '../organizational-units/organizationalUnit';

export interface Contract extends Base {
  name: string;
  minTimeBetweenShiftsInMinutes: number;
  maxShiftLengthInMinutes: number;
  maxDriveTimeInMinutes: number;
  maximumProtectiveWorkingTimeInMinutes: number;
  weekTimeInHours: number;
  maxTimeWithoutBreakInMinutes: number;
  minBreakTimeInMinutes: number;
  requiredBreakTime: RequiredBreakTime[];
  maximumContinuousWorkDays: number;
  minimumTimeBetweenRestDays: number;
  requiredRestDayDuration: number;
  organizationalUnit: OrganizationalUnit;
  organizationalUnitId: string;
  validFrom?: string;
  validTill?: string;
  activityCategoryContracts: ActivityCategoryContract[];
  users: User[];
}

export interface CreateContractDTO {
  name: string;
  minTimeBetweenShiftsInMinutes: number;
  maxShiftLengthInMinutes: number;
  maxDriveTimeInMinutes: number;
  weekTimeInHours: number;
  maxTimeWithoutBreakInMinutes: number;
  minBreakTimeInMinutes: number;
  maximumContinuousWorkDays: number;
  organizationalUnitId: string;
  maximumProtectiveWorkingTimeInMinutes: number;
  minimumTimeBetweenRestDays: number;
  requiredRestDayDuration: number;
  requiredBreakTime: RequiredBreakTime[];
}

export interface RequiredBreakTime {
  shiftTimeInMinutes: number;
  breakTimeInMinutes: number;
}

export enum ContractsNameModel {
  MaxDriveTimeInMinutes = 'maxDriveTimeInMinutes',
  MaxShiftLengthInMinutes = 'maxShiftLengthInMinutes',
  MaxTimeWithoutBreakInMinutes = 'maxTimeWithoutBreakInMinutes',
  MaximumContinuousWorkDays = 'maximumContinuousWorkDays',
  MinimumTimeBetweenRestDays = 'minimumTimeBetweenRestDays',
  MinBreakTimeInMinutes = 'minBreakTimeInMinutes',
  MinTimeBetweenShiftsInMinutes = 'minTimeBetweenShiftsInMinutes',
  WeekTimeInHours = 'weekTimeInHours',
  RequiredBreakTimeAfterShiftLengthOf = 'requiredBreakTimeAfterShiftLengthOf',
  RequiredBreakTime = 'requiredBreakTime',
  RequiredRestDayDuration = 'requiredRestDayDuration',
  MaximumProtectiveWorkingTimeInMinutes = 'maximumProtectiveWorkingTimeInMinutes',
}
